const storageKeys = {
  authToken: "mbh-auth-token",
  // authUserEmail: 'csl-fresh-auth-user-email',
  // authUserName: 'csl-fresh-auth-user-name',
  accountInformation: "mbh-vendor-account-information",
  // reduxState: 'csl-fresh-redux-state',
};

export default storageKeys;
